<template>
    <div class="nc-list-actions">
        <v-btn
            v-if="row['8d_disponibile']"
            small
            depressed
            color="primary"
            :disabled="disabled"
            :loading="opening8d === `${row.numero}:${row.riga}`"
            @click="$emit('open-8d', row)"
            >Apri 8D</v-btn
        >
        <v-btn
            v-if="canEdit"
            small
            :disabled="disabled"
            :outlined="row['8d_disponibile']"
            :depressed="!row['8d_disponibile']"
            :color="row['8d_disponibile'] ? undefined : 'primary'"
            @click="$emit('edit', row)"
        >{{ row.da_compilare ? 'Compila NC' : row['8d_disponibile'] ? 'Modifica NC' : 'Completa 8D' }}</v-btn>
    </div>
</template>
<script>
export default {
    props: {
        row: { type: Object, required: true },
        canEdit: Boolean,
        disabled: Boolean,
        opening8d: { type: String, default: null },
    },
};
</script>
<style scoped>
.nc-list-actions {
    display: flex;
    flex-wrap: wrap;
    gap: var(--space-2);
    margin-top: var(--space-2);
}
.nc-list-actions ::v-deep .v-btn {
    min-height: var(--touch-target);
}
</style>
